import { DynamicInputModel, serializable, DynamicFormControlLayout, DynamicInputModelConfig } from '@ng-dynamic-forms/core';
import { PageBuilderItem, PAGE_BUILDER_CODE_COMPONENT } from '../page-builder-components.models';

export interface PageBuilderDropdownModelConfig extends DynamicInputModelConfig {
    datas: any[];
	valueField: string;
	displayField: string;
}

export class PageBuilderDropdownModel extends DynamicInputModel {
	@serializable() readonly type: string = 'page_builder_dropdown'; 
	datas: any[];
	valueField: string;
	displayField: string;

	constructor(config: PageBuilderDropdownModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.datas = config.datas;
		this.valueField = config.valueField;
		this.displayField = config.displayField;
	}

	static initModel(_component: PageBuilderItem): PageBuilderDropdownModel { 
		const formModel = new PageBuilderDropdownModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE,
            datas: _component.DS_DATAS,
			valueField: _component.DS_VALUE_COLUMN_NAME,
			displayField: _component.DS_DISPLAY_COLUMN_NAME,
		});
		return formModel;
	}

	static getProperties() {
        return {
            CODE: PAGE_BUILDER_CODE_COMPONENT.DROPDOWN,
            NAME: 'Dropdown',
            ICON: 'text_fields',
            PROPERTIES: [
                { ID: 'GUID', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
            ]
        };
    }
}